export default __webpack_public_path__ + "static/media/Mark-6-HUD-02.b77622a6.jpg";